import { Shield, Code, Info, FileText, Heart } from 'lucide-react';
import { LATEST_VERSION } from '@/lib/changelog';
import { parseLocalDate } from '@/lib/helpers';

export function Footer({ minimal = false }) {
  const formattedDate = parseLocalDate(LATEST_VERSION.date).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

  return (
    <footer className="w-full mt-auto" data-testid="app-footer">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-1 text-center py-3 px-4">
        {!minimal && (
          <>
            <p className="text-gray-500 text-xs font-medium flex items-center gap-1 justify-center">
              <Heart className="w-3 h-3" /> CCBRJM - Gestão de Pessoas
            </p>
            <p className="text-gray-500 text-xs flex items-center gap-1 justify-center">
              <Code className="w-3 h-3" /> Versão {LATEST_VERSION.version} - {formattedDate}
            </p>
          </>
        )}
        <div className="flex flex-col sm:flex-row items-center gap-1.5 sm:gap-0 text-xs">
          <a
            href="/sobre"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline hover:underline-offset-2 font-bold transition-all cursor-pointer inline-flex items-center gap-1"
            data-testid="footer-about-btn"
          >
            <Info className="w-3 h-3" /> Sobre
          </a>
          <span className="hidden sm:inline text-gray-400 mx-1.5">|</span>
          <a
            href="/politica-de-privacidade"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline hover:underline-offset-2 font-bold transition-all cursor-pointer inline-flex items-center gap-1"
            data-testid="footer-privacy-link"
          >
            <Shield className="w-3 h-3" /> Política de Privacidade
          </a>
          <span className="hidden sm:inline text-gray-400 mx-1.5">|</span>
          <a
            href="/termos"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline hover:underline-offset-2 font-bold transition-all cursor-pointer inline-flex items-center gap-1"
            data-testid="footer-termos-link"
          >
            <FileText className="w-3 h-3" /> Termos de Uso
          </a>
        </div>
      </div>
    </footer>
  );
}
